// tslint:disable
/**
 * Learning group API
 * Used for: - Manage learning groups 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { LearningGroup } from '../models';
import { LearningGroupCreate } from '../models';
import { LearningGroupEdit } from '../models';
import { LearningGroupList } from '../models';
import { RegistrationList } from '../models';
/**
 * GroupApi - axios parameter creator
 * @export
 */
export const GroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create learning group.
         * @param {LearningGroupCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLearningGroup(body: LearningGroupCreate, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createLearningGroup.');
            }
            const localVarPath = `/learning-group`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete learning group.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLearningGroup(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteLearningGroup.');
            }
            const localVarPath = `/learning-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit learning group.
         * @param {string} id 
         * @param {LearningGroupEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editLearningGroup(id: string, body: LearningGroupEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editLearningGroup.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editLearningGroup.');
            }
            const localVarPath = `/learning-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get learning group.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningGroup(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getLearningGroup.');
            }
            const localVarPath = `/learning-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of learning group.
         * @param {string} companyId 
         * @param {Array<string>} [ids] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [title] 
         * @param {Array<string>} [registrationsIds] 
         * @param {Array<string>} [registrationsUserIds] 
         * @param {Date} [educationStartedAtMin] 
         * @param {Date} [educationStartedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'educationStartedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLearningGroup(companyId: string, ids?: Array<string>, responsibleId?: string, courseId?: string, title?: string, registrationsIds?: Array<string>, registrationsUserIds?: Array<string>, educationStartedAtMin?: Date, educationStartedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'educationStartedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling listLearningGroup.');
            }
            const localVarPath = `/learning-group`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (responsibleId !== undefined) {
                localVarQueryParameter['responsibleId'] = responsibleId;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (registrationsIds) {
                localVarQueryParameter['registrationsIds'] = registrationsIds.join(COLLECTION_FORMATS.csv);
            }

            if (registrationsUserIds) {
                localVarQueryParameter['registrationsUserIds'] = registrationsUserIds.join(COLLECTION_FORMATS.csv);
            }

            if (educationStartedAtMin !== undefined) {
                localVarQueryParameter['educationStartedAtMin'] = (educationStartedAtMin as any).toISOString();
            }

            if (educationStartedAtMax !== undefined) {
                localVarQueryParameter['educationStartedAtMax'] = (educationStartedAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLearningGroupAvailableRegistrations(courseId: string, offset?: number, limit?: number, options: any = {}): RequestArgs {
            // verify required parameter 'courseId' is not null or undefined
            if (courseId === null || courseId === undefined) {
                throw new RequiredError('courseId','Required parameter courseId was null or undefined when calling listLearningGroupAvailableRegistrations.');
            }
            const localVarPath = `/learning-group/available-registrations/list`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupApi - functional programming interface
 * @export
 */
export const GroupApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create learning group.
         * @param {LearningGroupCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLearningGroup(body: LearningGroupCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningGroup> {
            const localVarAxiosArgs = GroupApiAxiosParamCreator(configuration).createLearningGroup(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete learning group.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLearningGroup(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = GroupApiAxiosParamCreator(configuration).deleteLearningGroup(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Edit learning group.
         * @param {string} id 
         * @param {LearningGroupEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editLearningGroup(id: string, body: LearningGroupEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningGroup> {
            const localVarAxiosArgs = GroupApiAxiosParamCreator(configuration).editLearningGroup(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get learning group.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningGroup(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningGroup> {
            const localVarAxiosArgs = GroupApiAxiosParamCreator(configuration).getLearningGroup(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get list of learning group.
         * @param {string} companyId 
         * @param {Array<string>} [ids] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [title] 
         * @param {Array<string>} [registrationsIds] 
         * @param {Array<string>} [registrationsUserIds] 
         * @param {Date} [educationStartedAtMin] 
         * @param {Date} [educationStartedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'educationStartedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLearningGroup(companyId: string, ids?: Array<string>, responsibleId?: string, courseId?: string, title?: string, registrationsIds?: Array<string>, registrationsUserIds?: Array<string>, educationStartedAtMin?: Date, educationStartedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'educationStartedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningGroupList> {
            const localVarAxiosArgs = GroupApiAxiosParamCreator(configuration).listLearningGroup(companyId, ids, responsibleId, courseId, title, registrationsIds, registrationsUserIds, educationStartedAtMin, educationStartedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLearningGroupAvailableRegistrations(courseId: string, offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationList> {
            const localVarAxiosArgs = GroupApiAxiosParamCreator(configuration).listLearningGroupAvailableRegistrations(courseId, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GroupApi - factory interface
 * @export
 */
export const GroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create learning group.
         * @param {LearningGroupCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLearningGroup(body: LearningGroupCreate, options?: any) {
            return GroupApiFp(configuration).createLearningGroup(body, options)(axios, basePath);
        },
        /**
         * Delete learning group.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLearningGroup(id: string, options?: any) {
            return GroupApiFp(configuration).deleteLearningGroup(id, options)(axios, basePath);
        },
        /**
         * Edit learning group.
         * @param {string} id 
         * @param {LearningGroupEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editLearningGroup(id: string, body: LearningGroupEdit, options?: any) {
            return GroupApiFp(configuration).editLearningGroup(id, body, options)(axios, basePath);
        },
        /**
         * Get learning group.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningGroup(id: string, options?: any) {
            return GroupApiFp(configuration).getLearningGroup(id, options)(axios, basePath);
        },
        /**
         * Get list of learning group.
         * @param {string} companyId 
         * @param {Array<string>} [ids] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [title] 
         * @param {Array<string>} [registrationsIds] 
         * @param {Array<string>} [registrationsUserIds] 
         * @param {Date} [educationStartedAtMin] 
         * @param {Date} [educationStartedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'educationStartedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLearningGroup(companyId: string, ids?: Array<string>, responsibleId?: string, courseId?: string, title?: string, registrationsIds?: Array<string>, registrationsUserIds?: Array<string>, educationStartedAtMin?: Date, educationStartedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'educationStartedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
            return GroupApiFp(configuration).listLearningGroup(companyId, ids, responsibleId, courseId, title, registrationsIds, registrationsUserIds, educationStartedAtMin, educationStartedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLearningGroupAvailableRegistrations(courseId: string, offset?: number, limit?: number, options?: any) {
            return GroupApiFp(configuration).listLearningGroupAvailableRegistrations(courseId, offset, limit, options)(axios, basePath);
        },
    };
};

/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
export class GroupApi extends BaseAPI {
    /**
     * Create learning group.
     * @param {LearningGroupCreate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public createLearningGroup(body: LearningGroupCreate, options?: any) {
        return GroupApiFp(this.configuration).createLearningGroup(body, options)(this.axios, this.basePath);
    }

    /**
     * Delete learning group.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public deleteLearningGroup(id: string, options?: any) {
        return GroupApiFp(this.configuration).deleteLearningGroup(id, options)(this.axios, this.basePath);
    }

    /**
     * Edit learning group.
     * @param {string} id 
     * @param {LearningGroupEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public editLearningGroup(id: string, body: LearningGroupEdit, options?: any) {
        return GroupApiFp(this.configuration).editLearningGroup(id, body, options)(this.axios, this.basePath);
    }

    /**
     * Get learning group.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public getLearningGroup(id: string, options?: any) {
        return GroupApiFp(this.configuration).getLearningGroup(id, options)(this.axios, this.basePath);
    }

    /**
     * Get list of learning group.
     * @param {string} companyId 
     * @param {Array<string>} [ids] 
     * @param {string} [responsibleId] 
     * @param {string} [courseId] 
     * @param {string} [title] 
     * @param {Array<string>} [registrationsIds] 
     * @param {Array<string>} [registrationsUserIds] 
     * @param {Date} [educationStartedAtMin] 
     * @param {Date} [educationStartedAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'title' | 'educationStartedAt' | 'createdAt' | 'updatedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public listLearningGroup(companyId: string, ids?: Array<string>, responsibleId?: string, courseId?: string, title?: string, registrationsIds?: Array<string>, registrationsUserIds?: Array<string>, educationStartedAtMin?: Date, educationStartedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'educationStartedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
        return GroupApiFp(this.configuration).listLearningGroup(companyId, ids, responsibleId, courseId, title, registrationsIds, registrationsUserIds, educationStartedAtMin, educationStartedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} courseId 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public listLearningGroupAvailableRegistrations(courseId: string, offset?: number, limit?: number, options?: any) {
        return GroupApiFp(this.configuration).listLearningGroupAvailableRegistrations(courseId, offset, limit, options)(this.axios, this.basePath);
    }

}
